import {announce} from '@github-ui/aria-live'

// Resolve a human-friendly setting name from the nearest ancestor carrying a
// `data-setting-label`. The `.js-status-indicator` is always a descendant of its
// labeled element (the form, `.js-repo-option`, or `.form-checkbox`), so a single
// `closest` lookup covers every existing placement.
function settingLabel(indicator: Element): string | null {
  return indicator.closest<HTMLElement>('[data-setting-label]')?.getAttribute('data-setting-label') || null
}

// Announce an auto-save status change to screen readers. Success is polite,
// failure is assertive. When a label resolves the message is named, otherwise a
// generic fallback is used. `failureMessage` overrides the failure text (e.g. a
// server validation message) while keeping the assertive priority.
export function announceSettingStatus(indicator: Element, ok: boolean, options?: {failureMessage?: string}): void {
  const label = settingLabel(indicator)

  if (ok) {
    announce(label ? `${label} saved` : 'Setting saved')
  } else {
    announce(options?.failureMessage || (label ? `${label} could not be saved` : 'Setting could not be saved'), {
      assertive: true,
    })
  }
}
